import { render, staticRenderFns } from "./PShareLinkMenuTag.vue?vue&type=template&id=50966171&"
import script from "./PShareLinkMenuTag.vue?vue&type=script&lang=ts&"
export * from "./PShareLinkMenuTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports